<div class="relative w-full">
  <img src="/notice/notice-bg-mo.png" alt="top background" class="w-full flex lg:hidden" />
  <img src="/notice/notice-bg-pc.png" alt="top background" class="w-full hidden lg:flex" />

  <div class="absolute inset-0 flex flex-col justify-center gap-3 pt-14 px-4 lg:px-0 lg:container">
    <h1 class="text-white text-2xl lg:text-4xl font-bold">좋은공간, 기부사랑</h1>
    <p class="text-zinc-300 font-medium">Giving Back with Love</p>
  </div>
</div>

<div class="flex flex-col gap-4 lg:gap-10 px-4 lg:px-0 lg:max-w-6xl lg:mx-auto py-6 lg:py-12 w-full">
  <!-- 검색 및 TOTAL 영역 -->
  <div class="flex flex-col gap-3 lg:flex-row lg:justify-between lg:items-center">
    <!-- TOTAL -->
    <div class="flex items-center gap-1">
      <span class="text-zinc-800 text-sm">TOTAL</span>
      <span class="text-primary-500 text-sm">{{ totalCount() }}</span>
    </div>

    <!-- 검색창 -->
    <div class="search-box">
      <app-icon name="ic:round-search" class="size-5! text-zinc-400"></app-icon>
      <input type="text" placeholder="제목이나 내용으로 검색" [value]="query()" (input)="onSearch($event)" />
    </div>
  </div>

  <!-- 뉴스 카드 그리드 -->
  <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 lg:gap-6">
    @for (news of newsList(); track $index) {
    <a [routerLink]="[news.id]" class="col-span-1 bg-white overflow-hidden cursor-pointer">
      <div class="flex flex-col h-full">
        <img
          [src]="extractFirstImage(news.content) || '/home/donation-default.jpg'"
          (error)="$any($event.target).src = '/home/donation-default.jpg'"
          [alt]="news.title"
          class="w-full aspect-video object-cover rounded-xl" />
        <div class="flex flex-col gap-2 px-4 py-3">
          <h2 class="text-zinc-800 font-bold line-clamp-1">
            {{ news.title }}
          </h2>
          @if (news.content) {
          <p class="text-zinc-400 text-xs line-clamp-2 font-medium">
            {{ stripHtml(news.content) }}
          </p>
          }
          <p class="text-zinc-400 text-xs font-medium">
            {{ news.displayDate | date : 'yyyy.MM.dd' }}
          </p>
        </div>
      </div>
    </a>
    } @empty {
    <app-not-found [(query)]="query" [isLoading]="$newsData.isLoading()" class="col-span-2 lg:col-span-4">
      <span class="text-zinc-500 text-base">기부사랑 소식이 없습니다.</span>
    </app-not-found>
    }
  </div>

  <!-- 페이지네이션 -->
  @if (newsList().length > 0) {
  <app-pagination
    [currentPage]="currentPage()"
    [totalPages]="totalPages()"
    (pageChange)="onPageChange($event)"
    class="flex" />
  }
</div>
